import {
  sendEventBatch
} from "./chunk-MJSTSYLL.mjs";
import {
  cleanupEvents
} from "./chunk-KCD6RFQZ.mjs";
import {
  lockEvents
} from "./chunk-WGWMZ3QE.mjs";

// src/batching/send-events/send-events.ts
async function sendEvents(useBeacon = false) {
  if (typeof window !== "undefined" && window.yvaDatastore) {
    const endpoint = window.yvaDatastore.config.endpoint;
    lockEvents().then((events) => {
      const eventBatches = events.events?.reduce(
        (batches, currentEvent) => {
          if (window.yvaDatastore) {
            const context = window.yvaDatastore.contexts[currentEvent.contextId];
            if (context && context.status === "ready" && currentEvent) {
              if (!batches[currentEvent.contextId]) {
                batches[currentEvent.contextId] = { context: context.data, events: [] };
              }
              batches[currentEvent.contextId].events.push(currentEvent.data);
            }
          }
          return batches;
        },
        {}
      );
      if (eventBatches && Object.keys(eventBatches).length) {
        Promise.allSettled(
          Object.values(eventBatches).map((batchPayload) => {
            if (window.yvaDatastore) {
              return sendEventBatch(
                { payload: batchPayload, url: endpoint },
                { debug: window.yvaDatastore.config.debug ?? false, requestMode: useBeacon ? "beacon" : "fetch" }
              );
            }
          })
        ).then((batchResults) => {
          batchResults.forEach((batchResult, index) => {
            const batch = Object.values(eventBatches)[index];
            if (batchResult.status === "fulfilled") {
              batch.events.forEach((event) => {
                if (window.yvaDatastore) {
                  const lockedEvent = window.yvaDatastore.events.find(
                    (datastoreEvent) => datastoreEvent.data.eventId === event.eventId
                  );
                  if (lockedEvent) {
                    lockedEvent.status = "sent";
                    lockedEvent.lockId = null;
                  }
                }
              });
            } else {
              if (window.yvaDatastore && window.yvaDatastore.config.debug) {
                console.error(
                  "Error(s) sending events to API for contextId",
                  Object.keys(eventBatches)[index],
                  "\nReason:",
                  batchResult.reason
                );
                console.dir(Object.values(eventBatches)[index], { depth: null });
              }
              batch.events.forEach((event) => {
                if (window.yvaDatastore) {
                  const lockedEvent = window.yvaDatastore.events.find(
                    (datastoreEvent) => datastoreEvent.data.eventId === event.eventId
                  );
                  if (lockedEvent) {
                    lockedEvent.lockId = null;
                  }
                }
              });
            }
          });
          cleanupEvents();
        });
      }
    });
  }
}
async function sendEventsViaBeacon() {
  sendEvents(true);
}

export {
  sendEvents,
  sendEventsViaBeacon
};
